export enum ActionStatus {
  Pending = 'pending',
  Accepted = 'accepted',
  Rejected = 'rejected',
  Withdrawn = 'withdrawn',
  PendingWithdraw = 'pending_withdraw',
}
